export class HighFrequencyBackupSchedules {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "scheduleConfig",
            "baseName": "scheduleConfig",
            "type": "HighFrequencyBackupScheduleConfig",
            "format": ""
        },
        {
            "name": "backupRetentionDays",
            "baseName": "backupRetentionDays",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return HighFrequencyBackupSchedules.attributeTypeMap;
    }
    constructor() {
    }
}
